function ReportInstance() {
    "use strict";

    this.__type = 'ReportInstance:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.ReportId = -1;
    this.ReportName = '';
    this.ReportDescription = '';
    this.ReportStatus = -1; //Enum
    this.ReportGeneratedDate = new Date(DisplayLongDateTime(new Date()));
    this.UpdateDateUTC = new Date(DisplayLongDateTime(new Date()));
    this.AgentId = -1;
    this.OrganizationId = -1;
    this.UniqueName = '';
    this.IsDoc = 0;
    this.IsPDF = 0;
    this.IsXLS = 0;
    this.IsRTF = 0;
    this.IsTXT = 0;
    this.IsCSV = 0;
    this.DOCStatus = -1;
    this.PDFStatus = -1;
    this.XLSStatus = -1;
    this.RTFStatus = -1;
    this.TXTStatus = -1;
    this.CSVStatus = -1;
    this.DOCURL = '';
    this.PDFURL = '';
    this.XLSURL = '';
    this.RTFURL = '';
    this.TXTURL = '';
    this.CSVURL = '';

    this.SendEmail = false;
    this.Filter = [];
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = ReportInstance;
}